import { Box } from '@material-ui/core';

import { useTranslation } from '../../hooks/useTranslation';
import { Font } from '../Font';
import { Text } from '../Text';
import { CheckResultIcon } from './components/CheckResultIcon';

export const CheckResult = ({
  key,
  check,
}: {
  key: number | string;
  check: { passed?: boolean; name?: string; description: string };
}) => {
  const { hasTranslation } = useTranslation();
  return (
    <Box key={`to-do-${key}`} className={'to-do'} mb={1}>
      <CheckResultIcon passed={check.passed} />
      <Font variant={'body2'} color={'textSecondary'}>
        {check.name && hasTranslation(check.name) ? (
          <Text tId={check.name} />
        ) : check.description && hasTranslation(check.description) ? (
          <Text tId={check.description} />
        ) : (
          check.description
        )}
      </Font>
    </Box>
  );
};
